import CompanyDataForm from "./Forms/CompanyDataForm";
import React, {useCallback, useEffect, useState} from "react";
import {Company, Login} from "../../types/Subscription";
import {useAdmin} from "../../contexts/AdminContext";
import Heading from "../../components/Heading";
import IconButton from "../../components/IconButton";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import Button from "../../components/Button";
import {useGlobalContext} from "../../contexts/globalContext";
import {useTranslation} from "react-i18next";

const ChangeCompanyData: React.FC<{changePage: (p: string) => void}> = ({changePage}) => {
    const { user, service, getUser } = useAdmin()
    const [company, setCompany] = useState<Partial<Company>>({})
    const { showToast } = useGlobalContext()
    const {t} = useTranslation(['settings'])
    const changeData = useCallback((data: Partial<Company & Login>) => {
        setCompany(prevElement => ({...prevElement, ...data}))
    }, [])

    useEffect(() => {
        if (user) {
            const {email, agb, disclaimer, ...rest} = user
            setCompany(rest)
        }
    }, [user])

    const submit = useCallback(() => {
        service.updateUser(company).then((res) => {
            if (res.status === 200 ) {
                if (res.data?.data) {
                    getUser()
                    changePage('overview')
                }
                showToast('top-right', 'success', t("subscription.companyDataUpdatedSuccessfully"))
            } else {
                showToast('top-right', 'error', t("subscription.errorUpdatingCompanyData"))
            }
        })
    }, [company, service, showToast, t, changePage, getUser])

    return (
        <div className={'mt-3'}>
            <Heading level={3} classes={'mb-4'}>{t("subscription.adjustCompanyData")}</Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => changePage('overview')}
            >
                {t("subscription.back")}
            </IconButton>
            <CompanyDataForm data={company} changeData={changeData} showAGBandDisclaimer={false}/>
            <div className={'m-4 d-flex justify-content-end'}>
                <Button fn={() => submit()} hierarchy={'primary'} text={t("subscription.applyChanges")}/>
            </div>
        </div>
    )
}

export default ChangeCompanyData
